import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { imgsTopic4 } from "../../../assets/imgs/Tema4";
import { QuestionCardV3 } from "../../../components/common/QuestionCardV3";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const gameQuestion = [
	{
		id: 1,
		question: "Un cliente no presenta una identificación oficial o se encuentra totalmente borrosa o con tachaduras en sus datos o se niegue a presentar su información completa. ¿Qué debe hacerse?",
		img: imgsTopic4.ChicoMalo1,
		options: [
			{
				id: 1,
				text: "Permitirle hacer la operación y solicitar que dicte los datos que no pudieron ser visualizados en la identificación.",
			},
			{
				id: 2,
				text: "Permitirle hacer la operación y colocar cualquier información en los campos faltantes.",
			},
			{
				id: 3,
				text: "Negarle hacer la operación e indicarle que es necesario presentar una Identificación Oficial, además de proporcionar sus datos reales.",
				isCorrect: true
			},
		]
	},
	{
		id: 2,
		question: "Un cliente recurrente, presenta números de teléfono distintos cada vez que realiza una operación o cada vez le envía dinero a distintas personas ¿Qué debe hacerse?",
		img: imgsTopic4.ChicoMalo2,
		options: [
			{
				id: 1,
				text: "Indicarle que esta mal enviarle dinero a varias personas.",
			},
			{
				id: 2,
				text: "Realizar operación normalmente, pero dar aviso de la situación por medio de la herramienta ATL.",
				isCorrect: true,
			},
			{
				id: 3,
				text: "Indicarle que ponga el mismo número de teléfono en todas las operaciones.",
			},
		]
	},
]

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	questionActivity: 3,
	win: 4,
	fail: 5,
	fail2: 6,
}
export const Tema4SubtopicSixActivityTwo = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema4.activities.subtema6], 2);
	useEffect(() => {
		if (loaded) {
			console.log("tema 4 subtema6 activity 2");
			ObserverEmitter.emit(EVENTS.tema4.subtopicSix.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub06.sub6_act2_a01)
	})
	const [selectQuestionGame, setSelectQuestionGame] = useState({
		question: "",
		img: "",
		options: [
			{
				id: 1,
				text: ""
			},
			{
				id: 2,
				text: ""
			},
			{
				id: 3,
				text: ""
			},
		]
	})
	const [numberQuestion, setNumberQuestion] = useState(0)
	const [saveResponse, setSaveResponse] = useState(0)

	const actionGameQuestion = (statusCorrect = 0) => {
		const updatedResponse = statusCorrect === 1 ? saveResponse + 1 : saveResponse;
		setSaveResponse(updatedResponse);
		// console.log(updatedResponse);
		if (numberQuestion >= gameQuestion.length - 1) {
			if (updatedResponse === 2) {
				setUiToShow(steps.win);
			} else if (updatedResponse === 1) {
				setUiToShow(steps.fail);
			} else {
				setUiToShow(steps.fail2);
			}
			return;
		}

		setNumberQuestion(numberQuestion + 1);
	};

	const setDataQuestion = () => {
		const selectData = gameQuestion[numberQuestion]
		setSelectQuestionGame(selectData)
	}

	useEffect(() => {
		setDataQuestion()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [numberQuestion])

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, 3].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema4.subtopicSix.initScene, 2);
						setNumberQuestion(0)
						setSaveResponse(0)
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Ejercicio: Preguntas." />
					<DialogBarNew
						dialog={
							"Ahora, basándote en la información que has revisado, responde las siguientes preguntas."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.viewActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 6: Lavado de dinero"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto)
							setUiToShow(steps.questionActivity);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.questionActivity && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<BarStatusActivies activities={tasksList} />
					<QuestionCardV3 data={selectQuestionGame} actionGameQuestion={actionGameQuestion} />

				</>
			)}
			{uiToShow === steps.win && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={50}
						dialogModal="¡Felicidades por tu excelente labor en la detección de actividades sospechosas!"
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 50,
									subtema: tasksId.tema4.activities.subtema6,
								})
							);
							navigation("/home4/tema4/subtema6/results");
						}}
					/>
				</>
			)}
			{uiToShow === steps.fail && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="Respuesta incorrecta."
						numberPoints={25}
						dialogModal="Es importante detectar las actividades sospechosas relacionadas con el lavado de dinero o estafas."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 25,
									subtema: tasksId.tema4.activities.subtema6,
								})
							);
							navigation("/home4/tema4/subtema6/results");
						}}
					/>
				</>
			)}
			{uiToShow === steps.fail2 && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="Respuesta incorrecta."
						numberPoints={0}
						dialogModal="Es importante detectar las actividades sospechosas relacionadas con el lavado de dinero o estafas."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 0,
									subtema: tasksId.tema4.activities.subtema6,
								})
							);
							navigation("/home4/tema4/subtema6/results");
						}}
					/>
				</>
			)}
		</>
	)
}
